import { ModulePageLayout } from './ModulePageLayout';
import useFavorites from './useFavorites';

export * from './ModulePageLayout';
export { useFavorites };
export default ModulePageLayout;
